import { render, staticRenderFns } from "./SpecieHeader.vue?vue&type=template&id=212dd664&"
import script from "./SpecieHeader.vue?vue&type=script&lang=ts&"
export * from "./SpecieHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports